import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
  PolicyError,
  PolicyNotFound,
  PolicyPending,
} from "@/features/policies/navigation";

export const Route = createFileRoute("/_site/policies")({
  head: () => ({ meta: [{ title: "Policies | Softmax" }] }),
  component: PoliciesLayout,
  pendingComponent: PolicyPending,
  errorComponent: PolicyError,
  notFoundComponent: PolicyNotFound,
});

function PoliciesLayout() {
  return (
    <main
      id="main"
      data-shell-page
      tabIndex={-1}
      className="focus:outline-none"
    >
      <Outlet />
    </main>
  );
}
